var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width: 100%; height: " + _vm.photoSize))},[(_vm.isObjectPhoto)?_c('v-img',{attrs:{"position":"center center","max-width":'100%',"max-height":'100%',"src":_vm.loadPhoto(_vm.photo)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }